import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Paper } from '@mui/material';
import AppBindStyles from '../../AppBindStyles';
import AppDisplay from '../ui/AppDisplay';

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  tblHead: {
    backgroundColor: '#f1f1f1',
  },
  dbTile: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    marginLeft:   theme.spacing(1),
    marginTop:    theme.spacing(2),
    marginRight:  theme.spacing(1),
    marginBottom: theme.spacing(1),
    // height: 48,
    width: '92%',
    minWidth: 300,
  },
  dbTileSelected: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    marginLeft:   theme.spacing(1),
    marginTop:    theme.spacing(2),
    marginRight:  theme.spacing(1),
    marginBottom: theme.spacing(1),
    // height: 48,
    width: '92%',
    minWidth: 300,
    backgroundColor: '#D3D3D3'
  },
});

class StepApp extends React.Component {
   
  isAppSelected(app) {

    //if only 1 app auto-select
    if (this.props.apps.length === 1) {

      let appsSelected = this.props.appsSelected;
      if (appsSelected.length === 0) {
        appsSelected.push(app);
        //update stepper
        this.props.setAppStateChanged(appsSelected);
      }
      return true;
    }

    for (var i = 0; i < this.props.appsSelected.length; i++) {
      let appSelected = this.props.appsSelected[i];
      if (appSelected.appId === app.appId) {
        return true;
      }
    }
    return false;
  }

  isAnyAppSelected() {
    if (this.props.appsSelected.length === 0) {
      return false;
    } else {
      return true;
    }
  }

  isMoreThanOneAppSelected() {
    if (this.props.appsSelected.length > 1) {
      return true;
    } else {
      return false;
    }
  }

  selectOrUnselectApp(app) {
    
    //this toggles.  Adds the app if not in array or removes it if not
    //state is not mutable (thus the extra gyrations)

    if (this.isAppSelected(app)) {

      //app was not previously selected.  Add it
      let appsSelected = [];
      for (var i = 0; i < this.props.appsSelected.length; i++) {
        let appPreviouslySelected = this.props.appsSelected[i];
        if (appPreviouslySelected.appId === app.appId) {
          //do not add back into array as user is unselecting
        } else {
          appsSelected.push(appPreviouslySelected);
        }
      }
       //update stepper
       this.props.setAppStateChanged(appsSelected);

    } else {

      //app was not previously selected.  Add it and remove anything that was there.
      let appsSelected = [];
      appsSelected.push(app);
       //update stepper
      this.props.setAppStateChanged(appsSelected);
    }
    
   
  }

  isInformationComplete() {

    return this.isAnyAppSelected();

  }
  
  isBackDisabled() {
    if (this.props.activeStep === 0)
      return true;

    return false;
  }

  isNextDisabled() {
    
    if (this.props.activeStep === this.props.assignedStep) {
      if (!this.isInformationComplete()) {
        return true;
      } 
    }
    return false;
  }

  render() {

    const classes = this.props.classes;
   
    let displayOnly = false;
    if (this.props.activeStep > this.props.assignedStep) {
      displayOnly = true;
    } else if (this.props.displayOnly) {
      displayOnly = true;
    }

    if (!displayOnly) {

      return (

        <Grid container spacing={2}>
          { /* Example of titleLimit and descriptionLimit props
                  <AppDisplay appLogo={this.props.apps[0].appLogo}
                              appName={this.props.apps[0].appName}
                              appSku={this.props.apps[0].appSku}
                              displayForm='short'
                              titleLimit={30}
                              description={this.props.apps[0].description}
                              descriptionLimit={96}/>
             */}
          {this.props.appCount === 1 && 
            <Grid item xs={12}>

              <Paper className={(this.isAppSelected(this.props.apps[0]) ? classes.dbTile : classes.dbTile)} onClick={() => { this.selectOrUnselectApp(this.props.apps[0])  }}>
                  <AppDisplay appLogo={this.props.apps[0].appLogo}
                              appName={this.props.apps[0].appName}
                              appSku={this.props.apps[0].appSku}
                              description={this.props.apps[0].description}
                              displayForm='short'
                  />
             </Paper>
            </Grid>

          }

          {this.props.appCount > 1 &&
            <div>
                {this.props.apps.map(app => {

                  return(

                    <Grid item xs={12} style={{marginBottom: 8}} key={app.appId}>

                      <Paper className={(this.isAppSelected(app) ? classes.dbTileSelected : classes.dbTile)} onClick={() => { this.selectOrUnselectApp(app)  }}>
                        <AppDisplay appLogo={app.appLogo}
                                    appName={app.appName}
                                    appSku={app.appSku}
                                    description={app.description}
                                    displayForm="short"
                        />
                      </Paper>

                    </Grid>
                  );
                })}
            </div>
          }
   
          {this.props.activeStep === this.props.assignedStep &&
          <Grid item xs={12}>
            <Button
              disabled={this.isBackDisabled()}
              color="primary" variant="outlined"
              onClick={() => this.props.handleBack()}
              style={AppBindStyles.bottomButton}>
              Back
            </Button>
            <Button
              disabled={this.isNextDisabled()}
              color="primary" variant="contained"
              onClick={() => this.props.handleNext()}
              style={AppBindStyles.bottomButton}>
              Place Order
            </Button>
          </Grid>
          }
        </Grid>       
      );

    } else {
      //display only

      return (

        <Grid container spacing={2} style={{marginTop: 8}}>
          
          {this.isAnyAppSelected() && this.isMoreThanOneAppSelected() &&
          <Grid item  xs={12}  style={{marginBottom: 8}}>
              {this.props.appsSelected.map(app => {
                      
                  return(
                    <AppDisplay appLogo={app.appLogo}
                                appName={app.appName}
                                appSku={app.appSku}
                                description={app.description}
                                displayForm='short'
                    />
                  );
                })}
        
          </Grid>
          }


          {this.isAnyAppSelected() && !this.isMoreThanOneAppSelected() &&
          <Grid item  xs={12}>
            
            <AppDisplay appLogo={this.props.appsSelected[0].appLogo}
                        appName={this.props.appsSelected[0].appName}
                        appSku={this.props.appsSelected[0].appSku}
                        description={this.props.appsSelected[0].description}
                        displayForm='short'
            />
          </Grid>
          }

          {!this.isAnyAppSelected() &&
          <Grid item  xs={12}>
            
            {/* this should never happen */}
            
          </Grid>
          }

        </Grid>
          
      );
    }
  }
}


StepApp.propTypes = {
  /*appCount: PropTypes.number.isRequired,*/
  /*apps: PropTypes.array.isRequired,*/
  setAppStateChanged: PropTypes.func.isRequired,
  assignedStep: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired
};

export default withStyles(styleSheet)(StepApp);
